export const T = {
  en_GB: {
    productName: "Product Name",
    isin: "ISIN",
    amount: "Amount",
    weight: "Weight",
    total: "Total",
    portfolio: "Portfolio",
    snapshotTaken: "Snapshot taken",
    noProducts: "No products in this portfolio.",
    loading: "Loading...",
    productDetailsNotAvailable: "Product details not available.",
    unmatchableNoDetails:
      "This holding isn't the part of selected portfolio collection, so there's no additional information to show.",
    description: "Description",
    suitability: "Suitability",
    productType: "Product Type",
    minTimeHorizon: "Min. Time Horizon",
    minRiskTolerance: "Min. Risk Tolerance",
    wrapperTypes: "Wrapper Types",
    costs: "Costs",
    assetAllocation: "Asset Allocation",
    documents: "Documents",
  },
  nb_NO: {
    productName: "Produktnavn",
    isin: "ISIN",
    amount: "Beløp",
    weight: "Vekt",
    total: "Totalt",
    portfolio: "Portefølje",
    snapshotTaken: "Øyeblikksbilde tatt",
    noProducts: "Ingen produkter i denne porteføljen.",
    loading: "Laster...",
    productDetailsNotAvailable: "Produktdetaljer er ikke tilgjengelige.",
    unmatchableNoDetails:
      "Denne beholdningen er ikke en del av den valgte porteføljesamlingen, så det finnes ingen ytterligere informasjon å vise.",
    description: "Beskrivelse",
    suitability: "Egnethet",
    productType: "Produkttype",
    minTimeHorizon: "Min. tidshorisont",
    minRiskTolerance: "Min. risikotoleranse",
    wrapperTypes: "Innpakningstyper",
    costs: "Kostnader",
    assetAllocation: "Aktivaallokering",
    documents: "Dokumenter",
  },
} as const;
